import { setUser, setUserStatus as setUserStatusAction } from "../services/graphql/slices/authenticationSlice";
import { transformUser } from "./transform";

export function recievedSetUser(user) {
    const payload = Object.keys(user || {}).length > 0 ? transformUser(user) : null;
    return setUser(payload);
}

export function setUserStatus(status) {
    return setUserStatusAction(status);
}

export function receiveAmplifyHubUser(response = {}) {
    return function (dispatch) {
        if(response?.status) {
            dispatch(setUserStatus(response?.status))
        }
        if(['error', 'cleared'].includes(response?.status)) {
            dispatch(recievedSetUser({}));
        } else if(response?.osuid || response?.displayName) {
            dispatch(recievedSetUser(response));
        } 
    }
}
